"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.distance = {
    calculateDistance: function (currentPosition, dealerPosition) {
        var latitude1 = currentPosition.latitude;
        var longitude1 = currentPosition.longitude;
        var latitude2 = dealerPosition.latitude;
        var longitude2 = dealerPosition.longitude;
        var latitude1Radians = (latitude1 * Math.PI) / 180;
        var latitude2Radians = (latitude2 * Math.PI) / 180;
        var longitudeDifferenceRadians = ((longitude2 - longitude1) * Math.PI) / 180;
        var EarthRadius = 6371e3;
        var distance = Math.acos(Math.sin(latitude1Radians) * Math.sin(latitude2Radians) +
            Math.cos(latitude1Radians) * Math.cos(latitude2Radians) * Math.cos(longitudeDifferenceRadians)) * EarthRadius;
        return distance;
    },
};
